module.exports = __webpack_public_path__ + "img/scene1.bbdbd9cf.png";